
import { useState } from 'react';

const VideoGrid = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [playingVideos, setPlayingVideos] = useState<Set<number>>(new Set());

  const projects = [
    {
      title: "Filmagens aéreas que elevam a percepção da sua marca",
      subtitle: "Captação FPV e drones profissionais para construtoras, produtoras e agências",
      image: "https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/fffc0766362fd00ba27a4509a3e99fa2.png",
      isHero: true,
    },
    {
      title: "Hanami",
      subtitle: "Adriática Incorporadora",
      image: "https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/c519ce7bd5270db3b00a5a2bb887ca10.png",
      link: "https://www.instagram.com/reel/DDN7hhXMLSs/",
      type: "instagram",
    },
    {
      title: "SOHO 2525",
      subtitle: "Construtora Opera Prima",
      image: "https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/2cf227f3986c3819ef4fc709452c3386.png",
      link: "https://www.instagram.com/reel/DPCZIJwEhkh/",
      type: "instagram",
    },
    {
      title: "SOHO 2525",
      subtitle: "Construtora Opera Prima",
      image: "https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/90e08a6a6ed16266e8f7825ab6c4381a.png",
      link: "https://www.instagram.com/reel/DQFKkQxj9bw/",
      type: "instagram",
    },
    {
      title: "SOHO 2525",
      subtitle: "Construtora Opera Prima",
      image: "https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/f0a2dfa111102a5930e2c9a0e226391c.png",
      link: "https://www.instagram.com/reel/DP7RKv9D_vl/",
      type: "instagram",
    },
    {
      title: "SOHO 2525",
      subtitle: "Construtora Opera Prima",
      image: "https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/bb4345bd34fa5c7b5319e8d011eafd3a.png",
      link: "https://www.instagram.com/reel/DNybKkaUPY4/",
      type: "instagram",
    },
    {
      title: "Orquidaria Rosita",
      subtitle: "Prestinaria",
      image: "https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/c72cbe028420e8137020320573cef2b7.png",
      link: "https://www.instagram.com/p/DQQX1jGjFZa/",
      type: "instagram",
    },
    {
      title: "Projeto Sustentável",
      subtitle: "Scania Brasil",
      image: "https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/52766fe5484dbfd51e14ca94534c5e64.png",
      link: "https://www.instagram.com/p/DN8_F6CgUyJ/?img_index=1",
      type: "instagram",
    },
    {
      title: "Captação FPV",
      subtitle: "Viação Graciosa",
      image: "https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/2185cef2e459eccde2fd689ceb9059df.png",
      link: "https://www.instagram.com/reel/C_bGywhRlF8/",
      type: "instagram",
    },
    {
      title: "Bigorrilho",
      subtitle: "Sunset",
      image: "https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/f04309212978355aa1635975573826b0.png",
      link: "https://www.instagram.com/p/DNeUyPQPcpC/",
      type: "instagram",
    },
    {
      title: "Ilha do Mel",
      subtitle: "Farol das Conchas",
      image: "https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/f67544184d498e822d019e20b89b3d4a.png",
      link: "https://www.instagram.com/p/DCIiZzSs5kj/",
      type: "instagram",
    },
    {
      title: "Edifício Residencial Premium",
      subtitle: "Construtora Adriática",
      image: "https://img.youtube.com/vi/6m98RPsLBJ0/maxresdefault.jpg",
      link: "https://www.youtube.com/watch?v=6m98RPsLBJ0",
      videoId: "6m98RPsLBJ0",
      type: "youtube",
    },
    {
      title: "Sette Case",
      subtitle: "Construtora Hugo Peretti",
      image: "https://img.youtube.com/vi/QSd1wninRs8/maxresdefault.jpg",
      link: "https://www.youtube.com/watch?v=QSd1wninRs8",
      videoId: "QSd1wninRs8",
      type: "youtube",
    },
    {
      title: "De Immigrant",
      subtitle: "Moinho de Castrolanda",
      image: "https://img.youtube.com/vi/GX5gALkgvOI/maxresdefault.jpg",
      link: "https://www.youtube.com/watch?v=GX5gALkgvOI",
      videoId: "GX5gALkgvOI",
      type: "youtube",
    },
  ];

  const handleVideoClick = (project: any, index: number) => {
    if (project.type === 'youtube') {
      setPlayingVideos(prev => {
        const newSet = new Set(prev);
        if (newSet.has(index)) {
          newSet.delete(index);
        } else {
          newSet.add(index);
        }
        return newSet;
      });
    } else {
      window.open(project.link, '_blank');
    }
  };

  const stopVideo = (index: number, e: React.MouseEvent) => {
    e.stopPropagation();
    setPlayingVideos(prev => {
      const newSet = new Set(prev);
      newSet.delete(index);
      return newSet;
    });
  };

  return (
    <div className="pt-32 pb-16">
      {/* Hero Section */}
      <section className="relative h-screen mb-16">
        <div className="absolute inset-0">
          <img
            src={projects[0].image}
            alt={projects[0].title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#111111]/60 via-transparent to-[#111111]/80"></div>
        </div>

        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center max-w-4xl px-6">
            <h2 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              {projects[0].title}
            </h2>
            <p className="text-xl md:text-2xl text-[#C0C0C0] mb-8 font-light">
              {projects[0].subtitle}
            </p>
            <a
              href="#orcamento"
              className="inline-block bg-white text-[#111111] px-8 py-4 text-lg font-semibold hover:bg-[#C0C0C0] transition-colors duration-300 whitespace-nowrap cursor-pointer rounded-full"
            >
              Solicite um orçamento
            </a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="sobre" className="max-w-6xl mx-auto px-6 mb-20">
        <div className="text-center">
          <h3 className="text-3xl md:text-4xl font-bold mb-8">Quem Somos</h3>
          <div className="text-lg md:text-xl text-[#C0C0C0] leading-relaxed max-w-4xl mx-auto space-y-6">
            <p>
              Desde 2013, a Skyview Filmes é referência em imagens aéreas profissionais em Curitiba e região.
              Com mais de 12 anos de experiência em pilotagem de drones e produção audiovisual, unimos tecnologia, precisão e sensibilidade artística para capturar perspectivas únicas que valorizam marcas, obras e campanhas.
            </p>
            <p>
              Ao longo da nossa trajetória, já realizamos produções para grandes empreendimentos e construtoras renomadas, consolidando nossa presença entre os principais nomes do setor.
            </p>
            <p className="font-medium text-white">
              Na Skyview Filmes, cada voo é planejado com excelência — e cada imagem é pensada para inspirar, impressionar e transmitir confiança.
            </p>
          </div>
        </div>
      </section>

      {/* Portfolio Grid */}
      <section id="portfolio" className="mb-20">
        <div className="max-w-7xl mx-auto px-6">
          <h3 className="text-3xl md:text-4xl font-bold text-center mb-12">Portfólio</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.slice(1).map((project, index) => (
              <div
                key={index}
                className="group relative overflow-hidden bg-[#1a1f1a] cursor-pointer block"
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                onClick={() => handleVideoClick(project, index)}
              >
                <div className="aspect-[4/5] overflow-hidden relative">
                  {playingVideos.has(index) && project.type === 'youtube' ? (
                    <div className="relative w-full h-full">
                      <iframe
                        src={`https://www.youtube.com/embed/${project.videoId}?autoplay=1&rel=0&modestbranding=1&controls=1`}
                        title={project.title}
                        className="w-full h-full"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                      
                      {/* Controls overlay */}
                      <div className="absolute top-2 right-2 flex gap-2">
                        <button
                          onClick={(e) => stopVideo(index, e)}
                          className="w-8 h-8 bg-black/60 hover:bg-black/80 rounded-full flex items-center justify-center transition-colors"
                          title="Parar vídeo"
                        >
                          <i className="ri-stop-fill text-white text-sm"></i>
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            const iframe = e.currentTarget.closest('.relative')?.querySelector('iframe');
                            if (iframe && iframe.requestFullscreen) {
                              iframe.requestFullscreen();
                            }
                          }}
                          className="w-8 h-8 bg-black/60 hover:bg-black/80 rounded-full flex items-center justify-center transition-colors"
                          title="Tela cheia"
                        >
                          <i className="ri-fullscreen-line text-white text-sm"></i>
                        </button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <img
                        src={project.image}
                        alt={project.title}
                        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                        onError={(e) => {
                          if (project.type === 'youtube' && e.currentTarget.src.includes('maxresdefault')) {
                            e.currentTarget.src = project.image.replace('maxresdefault', 'hqdefault');
                          }
                        }}
                      />

                      {/* Platform Icon */}
                      <div className="absolute top-4 right-4 w-8 h-8 bg-black/60 rounded-full flex items-center justify-center">
                        {project.type === 'youtube' ? (
                          <i className="ri-youtube-fill text-red-500 text-lg"></i>
                        ) : (
                          <i className="ri-instagram-fill text-pink-500 text-lg"></i>
                        )}
                      </div>

                      {/* Play Button Overlay */}
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-colors">
                          <i className="ri-play-fill text-white text-2xl ml-1"></i>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {!playingVideos.has(index) && (
                  <div
                    className={`absolute inset-0 bg-gradient-to-t from-[#111111]/90 via-transparent to-transparent transition-opacity duration-300 ${
                      hoveredIndex === index ? 'opacity-100' : 'opacity-0'
                    }`}
                  >
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <h4 className="text-xl font-bold mb-2">{project.title}</h4>
                      <p className="text-[#C0C0C0] text-sm">{project.subtitle}</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* View More Button */}
          <div className="text-center mt-12">
            <a
              href="https://www.instagram.com/skyviewfilmes"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white py-3 px-6 rounded-full hover:opacity-90 transition-opacity"
            >
              <i className="ri-instagram-fill text-xl"></i>
              Ver mais no Instagram
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="servicos" className="max-w-6xl mx-auto px-6 mb-20">
        <h3 className="text-3xl md:text-4xl font-bold text-center mb-12">Serviços</h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="text-center p-6 border border-[#A2AEAB]/20 hover:border-[#C0C0C0]/40 transition-colors duration-300">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-camera-line text-3xl text-[#C0C0C0]"></i>
            </div>
            <h4 className="text-xl font-semibold mb-3">Captação Aérea Institucional</h4>
            <p className="text-[#A2AEAB] text-sm">
              Vídeos corporativos e institucionais com perspectivas únicas
            </p>
          </div>

          <div className="text-center p-6 border border-[#A2AEAB]/20 hover:border-[#C0C0C0]/40 transition-colors duration-300">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-building-line text-3xl text-[#C0C0C0]"></i>
            </div>
            <h4 className="text-xl font-semibold mb-3">Filmagem de Obras</h4>
            <p className="text-[#A2AEAB] text-sm">
              Documentação e acompanhamento de projetos construtivos
            </p>
          </div>

          <div className="text-center p-6 border border-[#A2AEAB]/20 hover:border-[#C0C0C0]/40 transition-colors duration-300">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-movie-line text-3xl text-[#C0C0C0]"></i>
            </div>
            <h4 className="text-xl font-semibold mb-3">Vídeos Publicitários</h4>
            <p className="text-[#A2AEAB] text-sm">
              Campanhas publicitárias com drones FPV imersivos
            </p>
          </div>

          <div className="text-center p-6 border border-[#A2AEAB]/20 hover:border-[#C0C0C0]/40 transition-colors duration-300">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-search-line text-3xl text-[#C0C0C0]"></i>
            </div>
            <h4 className="text-xl font-semibold mb-3">Inspeção de Prédios / Fachadas</h4>
            <p className="text-[#A2AEAB] text-sm">
              Parceria com engenheiros para inspeções técnicas detalhadas
            </p>
          </div>

          <div className="text-center p-6 border border-[#A2AEAB]/20 hover:border-[#C0C0C0]/40 transition-colors duration-300">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-scissors-line text-3xl text-[#C0C0C0]"></i>
            </div>
            <h4 className="text-xl font-semibold mb-3">Edição Inclusa</h4>
            <p className="text-[#A2AEAB] text-sm">
              Edição básica inclusa, edição completa sob orçamento
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VideoGrid;
